import {
  Body,
  RequestBadge,
  RequestCardHeader,
  RequestCardTitle,
  RequestInfoBlock,
  StyledTypographyDateValue
} from '@components/TicketBox/styled'
import { Typography } from '@mui/material'
import { FiltersStatusesEnum, TicketCounterStatuses } from '@appTypes/enums/filters'
import { ViewComponentsProps } from '@components/TicketBox/types'
import Courses from '../Courses'
import Members from '../Members'

const formatResponseWindow = (seconds?: number) => {
  if (!seconds || seconds <= 0) {
    return 'expired'
  }

  const hours = Math.floor(seconds / 3600)
  const minutes = Math.ceil((seconds % 3600) / 60)

  if (hours <= 0) {
    return `${minutes}m left`
  }

  return `${hours}h ${minutes}m left`
}

const OpenTicketsView = ({ page, date, ticket }: ViewComponentsProps) => {
  const { direction, offerStatus, availability, comment, ticketCourse, ticketCourses } = ticket
  const primaryCourse = ticketCourse?.course || ticketCourses?.[0]?.course
  const title = primaryCourse?.name || (direction === 'inbound' ? 'Inbound Request' : 'Outbound Request')
  const email = direction === 'inbound' ? ticket.club?.email : primaryCourse?.email
  const shouldShowCourses = direction !== 'inbound'
  const isPendingRequest = direction && ticket.status === FiltersStatusesEnum.PENDING
  const isExpiredOutreach = ticket.outreachStatus === 'expired'
  const routeStage = [ticket.outreachCourseName, ticket.outreachStage && `(${ticket.outreachStage})`]
    .filter(Boolean)
    .join(' ')
  const pendingLabel =
    isExpiredOutreach
      ? 'Expired'
      : ticket.timeLeftSeconds !== undefined
        ? `Pending - ${routeStage ? `${routeStage} - ` : ''}${formatResponseWindow(ticket.timeLeftSeconds)}`
        : routeStage
          ? `Pending - ${routeStage}`
          : 'Pending'

  return (
    <Body page={page}>
      <RequestCardHeader>
        <RequestCardTitle>{title}</RequestCardTitle>
        {isPendingRequest ? (
          <RequestBadge variantType={isExpiredOutreach ? 'expired' : 'pending'}>
            {pendingLabel}
          </RequestBadge>
        ) : direction ? (
          <RequestBadge variantType='direction'>{direction}</RequestBadge>
        ) : null}
      </RequestCardHeader>

      <RequestInfoBlock>
        <Typography component='h5' variant='h5'>
          Date and Time
        </Typography>
        <StyledTypographyDateValue>
          {(
            offerStatus === TicketCounterStatuses.PENDING ||
            offerStatus === TicketCounterStatuses.NO_OFFER)
            ?
            (
              <>
                {date.format('MMM D, YYYY (dddd)')} {date.format('hh:mm A')}
                {' - '}
                {date.add(availability, 'minutes').format('hh:mm A')}
              </>
            )
            :
            (
              <>
                {date.format('MMM D, YYYY (dddd)')} {date.format('hh:mm A')}
              </>
            )}
        </StyledTypographyDateValue>
      </RequestInfoBlock>

      {shouldShowCourses ? <Courses page={page} ticket={ticket} /> : null}

      {email ? (
        <RequestInfoBlock>
          <Typography component='h5' variant='h5'>
            E-Mail
          </Typography>
          <Typography component='p'>{email}</Typography>
        </RequestInfoBlock>
      ) : null}

      <Members ticket={ticket} />
      <RequestInfoBlock>
        <Typography component='h5' variant='h5'>
          Comment
        </Typography>
        <Typography component='p'>{comment}</Typography>
      </RequestInfoBlock>
    </Body>
  )
}

export default OpenTicketsView
